module.exports = __webpack_public_path__ + "img/qr-url-400px.61dd474f.png";